import { useQuery } from "@tanstack/react-query";
import { getClientById } from "../../api/apiClients";

/**
 * Hook لجلب عميل واحد
 * @param {number|string} id - Client ID
 */
export function useGetClient(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["client", id],
        queryFn: () => getClientById(id),
        enabled: !!id,
        retry: false,
    });

    const client = data?.data || null;

    return { isLoading, error, client, refetch };
}